import { ApiError, apiFetch, authHeader, getApiBaseUrl } from "./config.js";
import { fetchSourceDocumentLink } from "./ingestion.js";
/** A signed link to the stored spreadsheet of one state's ongoing disputes ("UP", "AS", "KA", "MP"), or null when it is not in the store. */
export async function getDisputesSheetLink(state, signal) {
    return fetchSourceDocumentLink(`/documents/disputes/${encodeURIComponent(state)}/file-url`, signal);
}
/** The rows of one state's ongoing-disputes list, for the in-page sheet viewer. */
export async function getDisputesSheetRows(state, signal) {
    return apiFetch(`/documents/disputes/${encodeURIComponent(state)}/rows`, { signal });
}
/** Wrap in `useQuery` with queryKey `["document-section", sectionId]`. */
export async function getDocumentSection(sectionId, signal) {
    return apiFetch(`/documents/sections/${sectionId}`, { signal });
}
export async function getDocumentSectionPdf(sectionId, signal) {
    const url = `${getApiBaseUrl()}/documents/sections/${sectionId}/pdf`;
    const response = await fetch(url, { signal, headers: authHeader() });
    if (response.status === 404)
        return null;
    if (!response.ok) {
        const text = await response.text();
        const parsed = text ? JSON.parse(text) : undefined;
        throw new ApiError(`Request to ${url} failed with status ${response.status}`, response.status, url, parsed);
    }
    const blob = await response.blob();
    const pageStart = response.headers.get("X-Source-Page-Start");
    const pageEnd = response.headers.get("X-Source-Page-End");
    return {
        blob,
        contentType: response.headers.get("Content-Type") ?? "application/pdf",
        pageStart: pageStart ? Number(pageStart) : null,
        pageEnd: pageEnd ? Number(pageEnd) : null,
        paragraphRef: response.headers.get("X-Source-Paragraph-Ref"),
    };
}
/** Signed, Range-capable URL for one indexed section's PDF, or `null` when it isn't stored. */
export function getDocumentSectionPdfLink(sectionId, signal) {
    return fetchSourceDocumentLink(`/documents/sections/${sectionId}/pdf-url`, signal);
}
/** Signed, Range-capable URL for one read order's PDF, opened at `page` when given; `null` when it isn't stored. */
export function getSourceDocumentPdfLink(sourceDocumentId, page, signal) {
    const query = page ? `?page=${page}` : "";
    return fetchSourceDocumentLink(`/documents/source/${sourceDocumentId}/pdf-url${query}`, signal);
}
